import { gql } from '@apollo/client';
import { BUDGET_ITEM_WITH_CATEGORY } from './budgetItems';

// Fragment para ActionBudgetItem
export const ACTION_BUDGET_ITEM_BASIC = gql`
  fragment ActionBudgetItemBasic on ActionBudgetItem {
    id
    actionId
    budgetItemId
    quantity
    totalAmount
    createdAt
  }
`;

// Fragment para ActionBudgetItem con relaciones
export const ACTION_BUDGET_ITEM_WITH_RELATIONS = gql`
  fragment ActionBudgetItemWithRelations on ActionBudgetItem {
    ...ActionBudgetItemBasic
    action {
      id
      indexExpedition
      indexType
      registerInitDate
      roid
      actionTitle
    }
    budgetItem {
      ...BudgetItemWithCategory
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Obtener partidas de una acción
export const GET_ACTION_BUDGET_ITEMS = gql`
  query GetActionBudgetItems($actionId: ID!) {
    actionBudgetItems(actionId: $actionId) {
      ...ActionBudgetItemWithRelations
    }
  }
  ${ACTION_BUDGET_ITEM_WITH_RELATIONS}
`;

// Obtener una partida específica de una acción
export const GET_ACTION_BUDGET_ITEM = gql`
  query GetActionBudgetItem($id: ID!) {
    actionBudgetItem(id: $id) {
      ...ActionBudgetItemBasic
      budgetItem {
        ...BudgetItemWithCategory
      }
    }
  }
  ${ACTION_BUDGET_ITEM_BASIC}
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Obtener resumen de costos de una acción (solo COEX/ADMIN)
export const GET_ACTION_COST_SUMMARY = gql`
  query GetActionCostSummary($actionId: ID!) {
    actionCostSummary(actionId: $actionId) {
      actionId
      totalCost
      itemCount
      costByCategory {
        code
        name
        color
        totalCost
        itemCount
      }
      items {
        id
        code
        description
        unit
        unitPrice
        quantity
        totalAmount
        category {
          code
          name
          color
        }
      }
    }
  }
`;
